/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-department.reducer';

export const LabDepartmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labDepartmentEntity = useAppSelector(state => state.labDepartment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labDepartmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labDepartment.detail.title">LabDepartment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labDepartment.id">Id</Translate>
            </span>
          </dt>
          <dd>{labDepartmentEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labDepartment.active">Active</Translate>
            </span>
          </dt>
          <dd>{labDepartmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.labDepartment.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{labDepartmentEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.labDepartment.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{labDepartmentEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labDepartment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labDepartmentEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labDepartment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labDepartmentEntity.cursor}</dd>
          <dt>
            <span id="department">
              <Translate contentKey="tinyMedicRestApp.labDepartment.department">Department</Translate>
            </span>
          </dt>
          <dd>{labDepartmentEntity.department}</dd>
          <dt>
            <span id="group">
              <Translate contentKey="tinyMedicRestApp.labDepartment.group">Group</Translate>
            </span>
          </dt>
          <dd>{labDepartmentEntity.group}</dd>
          <dt>
            <span id="subGroup">
              <Translate contentKey="tinyMedicRestApp.labDepartment.subGroup">Sub Group</Translate>
            </span>
          </dt>
          <dd>{labDepartmentEntity.subGroup}</dd>
        </dl>
        <Button tag={Link} to="/lab-department" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-department/${labDepartmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabDepartmentDetail;
